export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      'Tenía los entrenos de natación en una app, los de bici en un Excel y los de carrera en notas del móvil. Con los seis volúmenes por fin lo tengo todo en un mismo sitio y sé para qué sirve cada semana.',
    name: 'Javier R.',
    location: 'Madrid · España',
    flag: '🇪🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/8817eedf-d393-476f-a36c-55678b868636.jpg',
  },
  {
    quote:
      'La natación siempre era la sesión que me saltaba. Ver natación, bici y carrera organizadas juntas me ayudó a dejar de tratarlas como tres deportes separados. Ahora mis semanas están mucho más equilibradas.',
    name: 'Daniela G.',
    location: 'Ciudad de México · México',
    flag: '🇲🇽',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/6d3abdfd-fc41-4dd5-84c7-bc97afaf97f6.jpg',
  },
  {
    quote:
      'Con 45 años y laburando todo el día, no puedo desperdiciar entrenamientos. El planificador de 12 semanas me mostró dónde estoy y qué viene después. Ya no ando adivinando si hago de más o de menos.',
    name: 'Martín F.',
    location: 'Buenos Aires · Argentina',
    flag: '🇦🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/6eb9e57a-0408-4d4e-96d5-b4e61f6fe60c.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      'La guía de nutrición era la pieza que me faltaba. Siempre me quedaba sin energía en las salidas largas. Ahora organizo lo que voy a comer antes de la sesión y no a mitad de camino.',
    name: 'Valentina C.',
    location: 'Bogotá · Colombia',
    flag: '🇨🇴',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/81d9fcdf-0fc2-4d86-9a6c-399efc95d4d5.jpg',
  },
  {
    quote:
      'El registro de rendimiento me mantiene constante. Ver mi semana completa en las tres disciplinas me dice mucho más que cualquier entrenamiento duro suelto. Lo uso hasta en los días de rodillo en casa.',
    name: 'Felipe A.',
    location: 'Santiago · Chile',
    flag: '🇨🇱',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/7d0de494-4730-4ab0-a7d5-cea795f84e6a.jpg',
  },
  {
    quote:
      'La semana de la carrera antes era un caos. Con el checklist lo tuve todo listo: bolsas preparadas, transiciones claras y la mañana organizada. Por primera vez llegué tranquila a la salida.',
    name: 'Lucía M.',
    location: 'Valencia · España',
    flag: '🇪🇸',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/78e14813-ce05-43bf-b85a-be5e8f7ebea9.jpg',
  },
];
